export const LOC = {
  page: "locations-page",
  title: "locations-title",
  newBtn: "new-location-btn",
  search: "location-search-input",
  table: "locations-table",
  emptyState: "locations-empty",
  loading: "locations-loading",
  row: "loc-row",
  viewFhirBtn: "loc-view-fhir-btn",
  editBtn: "loc-edit-btn",
  deleteBtn: "loc-delete-btn",
  // form
  form: "location-form",
  fName: "loc-field-name",
  fStatus: "loc-field-status",
  fType: "loc-field-type",
  fPhysical: "loc-field-physical-type",
  fOrg: "loc-field-organization",
  fDescription: "loc-field-description",
  fAlias: "loc-field-alias",
  fPhone: "loc-field-phone",
  fFax: "loc-field-fax",
  fEmail: "loc-field-email",
  fLine1: "loc-field-line1",
  fLine2: "loc-field-line2",
  fCity: "loc-field-city",
  fState: "loc-field-state",
  fPostal: "loc-field-postal",
  fCountry: "loc-field-country",
  saveBtn: "location-save-btn",
  cancelBtn: "location-cancel-btn",
  deleteDialog: "delete-location-dialog",
  confirmDelete: "confirm-delete-location-btn",
  // nav
  navOrganizations: "nav-organizations",
  navLocations: "nav-locations",
};
